import { render, staticRenderFns } from "./VirtualWaterSurfaceLayers.vue?vue&type=template&id=48d1660b&scoped=true&"
import script from "./VirtualWaterSurfaceLayers.vue?vue&type=script&lang=js&"
export * from "./VirtualWaterSurfaceLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1660b",
  null
  
)

export default component.exports